import React, { useEffect, useState } from 'react';
import Navigation from './Navigation';
import { BiSolidGrid } from "react-icons/bi";
import { BiSolidGridAlt } from "react-icons/bi";
import { AnimatePresence, motion } from "framer-motion";
import ProductCard from './ProductCard';
import CategoryTree from './layouts/categoryTree';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Loading from './layouts/Loading';
import Filters from './Filters';

function Products() {
  const category_id = useParams();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [list, setList] = useState(4);
  const [categories, setCategories] = useState([]);
  const [isShipping, setIsShipping] = useState(0);
  const [minPrice, setMinPrice] = useState('');
  const [maxPrice, setMaxPrice] = useState('');

  const handleFilterShipping = (e) => {
    setIsShipping(e.target.checked ? 1 : 0);
  }

  useEffect(() => {
    axios.get('api/tree/categorylist').then(res => {
      setCategories(res.data.categories);
    })
  }, [])

  useEffect(() => {
    setLoading(true);
    axios.get(`api/products/basedoncategory/${category_id.id}/${isShipping}/${minPrice}/${maxPrice}`)
      .then(res => {
        setProducts(res.data);
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [category_id, isShipping, minPrice, maxPrice]);

  const handleList = (num) => {
    setList(num);
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 1 }}
    >
      <Navigation name="CategoryName" />

      <div className='p-4 mt-4 gap-6 grid md:grid-cols-4 lg:grid-cols-4 sm:grid-cols-2 xl:grid-cols-4 grid-cols-1 max-w-7xl mx-auto'>
        {/* Sidebar Filters Section */}
        <div className='col-span-1 space-y-6'>
          {/* Filters Component */}
          <div className='bg-white rounded-xl shadow-sm p-4 border border-gray-100'>
            <Filters handleFilterShipping={handleFilterShipping} />
          </div>

          {/* Price Range Filter */}
          <div className='bg-white rounded-xl shadow-sm p-4 border border-gray-100'>
            <h3 className='text-gray-700 font-semibold text-lg mb-3 font-serif'>Price Range</h3>
            <div className='flex gap-3'>
              <div className='flex-1'>
                <label className='text-xs text-gray-500 mb-1 block'>Min Price</label>
                <input
                  className='w-full px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all'
                  value={minPrice}
                  onChange={(e) => setMinPrice(e.target.value)}
                  placeholder='Min'
                  type='text'
                />
              </div>
              <div className='flex-1'>
                <label className='text-xs text-gray-500 mb-1 block'>Max Price</label>
                <input
                  className='w-full px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all'
                  value={maxPrice}
                  onChange={(e) => setMaxPrice(e.target.value)}
                  placeholder='Max'
                  type='text'
                />
              </div>
            </div>
          </div>

          {/* Sub Categories Section */}
          <div className='bg-white rounded-xl shadow-sm p-4 border border-gray-100'>
            <h3 className='text-gray-700 font-semibold text-lg mb-2 font-serif'>Browse Sub Categories</h3>
            <hr className='border-gray-200 mb-4' />
            <div className='space-y-1'>
              <CategoryTree categories={categories} />
            </div>
          </div>
        </div>

        {/* Products Grid Section */}
        <div className='col-span-3'>
          {/* Header with Results Count and View Options */}
          <div className='flex justify-between items-center mb-6 px-2'>
            <div className='text-gray-600 font-medium'>
              Showing <span className='text-blue-600 font-semibold'>{products.length}</span> results
            </div>
            <div className='flex gap-3 items-center bg-gray-50 rounded-lg p-1'>
              <button
                onClick={() => handleList(4)}
                className={`p-2 rounded-md transition-all ${list === 4 ? 'bg-white shadow-md text-blue-600' : 'text-gray-500 hover:text-gray-700'}`}
              >
                <BiSolidGrid size={22} />
              </button>
              <button
                onClick={() => handleList(2)}
                className={`p-2 rounded-md transition-all ${list === 2 ? 'bg-white shadow-md text-blue-600' : 'text-gray-500 hover:text-gray-700'}`}
              >
                <BiSolidGridAlt size={22} />
              </button>
            </div>
          </div>

          {/* Products Display */}
          {loading ? (
            <div className="flex justify-center items-center min-h-[400px]">
              <Loading />
            </div>
          ) : (
            <AnimatePresence mode="wait">
              <motion.div
                key={products.length}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.5 }}
              >
                {products.length > 0 ? (
                  <ProductCard data={products} listGrid={list} />
                ) : (
                  <div className='flex flex-col items-center justify-center min-h-[400px] bg-gray-50 rounded-xl'>
                    <div className='text-6xl mb-4'>🔍</div>
                    <p className='text-red-500 text-lg font-medium'>No Results Found</p>
                    <p className='text-gray-400 text-sm mt-2'>Try adjusting your filters</p>
                  </div>
                )}
              </motion.div>
            </AnimatePresence>
          )}
        </div>
      </div>
    </motion.div>
  );
}

export default Products;